import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-prelisten-back-icon',
  templateUrl: './prelisten-back-icon.component.html',
  styleUrls: ['./prelisten-back-icon.component.scss']
})
export class PrelistenBackIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
